import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class DonutChartComponent implements OnInit {
  @Input() hasSurvey:boolean = false;
  @Input() target_cnt:number = 0;
  @Input() read_cnt:number = 0;
  @Input() reply_cnt:number = 0;
  constructor(
  ) {
  }
  ngOnInit () {
  }

}    